import ModalImage from "react-modal-image"
import Dot from "../../../components/Dot"
import { getDateFormat, getTimeFormat, getValidDateFormat } from "../../../helpers/utils"

export default function ShippingInfo({orderInfo})
    {
        return orderInfo ? <div className='block grid-cols-12 flex-1 overflow-scroll bg-white w-full py-10 px-4 gap-x-4'>
        <div className='col-span-9'>
    <div className='grid  grid-cols-3 gap-6 w-full border-b border-[#e3e3e3] pb-6 mb-10'>
        <div>
            <label className='uppercase font-semibold text-[#959595] tracking-normal'>Status</label>
            <p className='text-sm text-black font-medium'>{orderInfo?.status === 0 ? 'Ready to Ship' : 'Shipped'}</p>
        </div>

    </div>

    </div>
        
    </div> : <p className="text-xs text-[#95959]">Shipping Order Not Created</p>
    }